export const ERROR_MESSAGES = {
  LOGIN_CHALLENGE_EXISTING: 'Login failed, challenge existing: ',
  RESPOND_TO_AUTH_CHALLENGE_NOT_HANDLED:
    'No handler for this challenge existing.',
  REFRESH_TOKEN_NOT_AUTHENTICATED:
    'Token refresh failed. User not authenticated.',
};
